import { ApiService } from "../..";

export const getAllSampleLabel = () => {
    return ApiService.baseAction("sample-label/all/", {}, "get");
    
};